import{styled}from"styled-components";export const Footer=/*#__PURE__*/styled.footer.withConfig({componentId:"sc-jrgebh-0"})`display:flex;flex-direction:column;justify-self:flex-end;gap:24px;`;
//# sourceMappingURL=footer.styles.js.map